import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import ProblemSection from "@/components/ProblemSection";
import SolutionSection from "@/components/SolutionSection";
import ValueProposition from "@/components/ValueProposition";
import HowItWorks from "@/components/HowItWorks";
import PricingSection from "@/components/PricingSection";
import SocialProof from "@/components/SocialProof";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

const LandingPage = () => {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-white">
      <Navigation />
      <main>
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <ValueProposition />
        <HowItWorks />
        <PricingSection />
        <SocialProof />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
